import { AmbientLight, Color, DirectionalLight, Group } from 'three';
import type { TrackVisualManifestV1 } from '../assets/TrackVisualManifest';

/**
 * Blender sun strength is irradiance (W/m²) and Three.js punctual intensity is
 * irradiance too, so the sun maps 1:1. Blender's world colour is uniform
 * radiance; Three.js ambient intensity is irradiance (π × radiance). Both were
 * checked by eye against the Blender ground bake.
 */
export const K_SUN = 1;
export const K_AMBIENT = Math.PI;
const SUN_DISTANCE = 2000;

/** App-owned lights approximating the bake; no shadow maps (shadows are baked). */
export function createSceneLights(manifest: TrackVisualManifestV1): Group {
  const { lighting, mapWidth, mapHeight } = manifest;
  const lights = new Group();
  lights.name = 'trackSceneLights';
  const sun = new DirectionalLight(new Color(...lighting.sunColor), lighting.sunIntensity * K_SUN);
  const [dx, dy, dz] = lighting.sunDirection;
  sun.position.set(
    mapWidth / 2 + dx * SUN_DISTANCE,
    dy * SUN_DISTANCE,
    mapHeight / 2 + dz * SUN_DISTANCE,
  );
  sun.target.position.set(mapWidth / 2, 0, mapHeight / 2);
  lights.add(sun, sun.target);
  lights.add(
    new AmbientLight(new Color(...lighting.ambientSky), lighting.ambientIntensity * K_AMBIENT),
  );
  return lights;
}
